import MessageClient from "./MessageClient";
import { Constants } from "../../constants/constants";
import { IDiscussion, IPagedList } from "../../commons/interfaces";

interface IRequestGetPagedDiscussion {
    type: number;
    endIn: number;
    replyTo?: string;
    threadId?: string;
    pageNumber: number;
    referenceId: string;
}

interface IReqCreateEdit {
    userId?: string,
    channelId?: string,
    threadId?: string,
    discussionValue?: string,
    replyTo?: string,
    files?: {
        fileId?: string,
        fileUrl?: string,
        sequence?: number,
    }[],
}

interface IReqUpdate {
    id: string,
    userId: string,
    discussionValue: string,
    files?: {
        fileId?: string,
        fileUrl?: string,
        sequence?: number,
    }[],
}

const DiscussionService = {
    getPaged: async (request: IRequestGetPagedDiscussion): Promise<IPagedList<IDiscussion>> => {
        const result = await MessageClient().get(Constants.ApiPath.Discussion.GET_PAGED, {
            params: {
                ...request,
            },
        });
        return result.data.result;
    },

    create: async (request: IReqCreateEdit): Promise<IDiscussion[]> => {
        const result = await MessageClient().post(Constants.ApiPath.Discussion.CREATE, request);
        return result.data.result;
    },

    update: async (request: IReqUpdate): Promise<IDiscussion> => {
        const result = await MessageClient().post(Constants.ApiPath.Discussion.UPDATE, request);
        return result.data.result;
    },

    delete: async (request: { id: string, userId: string }): Promise<any> => {
        const result = await MessageClient().delete(Constants.ApiPath.Discussion.DELETE, { data: request });
        return result.data.result;
    },
};

export default DiscussionService;
